var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ResizableContent",
    {
      key: _vm.maxGridConversationsWidth + "" + _vm.minGridConversationsWidth,
      staticClass: "conversations",
      attrs: {
        handles: ["mr"],
        onResize: _vm.onResizeConversations,
        "max-width": _vm.maxGridConversationsWidth,
        "min-width": _vm.minGridConversationsWidth,
        width: _vm.width,
      },
    },
    [
      _c("div", { staticClass: "head-content" }, [
        _vm.searchMode
          ? _c("div", { staticClass: "search-area" }, [
              _c(
                "div",
                { staticClass: "chat-search-wrapper" },
                [
                  _c("a-input", {
                    staticClass: "search-input",
                    attrs: { value: _vm.filters.query, placeholder: "Search" },
                    on: { input: _vm.querySearch },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "prefix",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "material-icons" }, [
                                _vm._v("search"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3791802071
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "search-close-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    on: { click: _vm.closeSearchMode },
                  },
                  [_vm._v("close")]
                ),
              ]),
            ])
          : _c("div", { staticClass: "title-content" }, [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("span", { staticClass: "title-text" }, [
                    _vm._v(_vm._s(_vm.$t("message.chatsTitle"))),
                  ]),
                  _vm._v(" "),
                  !_vm.chatListToolbarLocked ? _c("ContactSorter") : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c(
                  "div",
                  { staticClass: "secondary-content" },
                  [
                    _c("ContactSwitcherButton"),
                    _vm._v(" "),
                    !_vm.chatListToolbarLocked
                      ? _c(
                          "div",
                          { staticClass: "chat-search-content" },
                          [
                            _c(
                              "SupsisButton",
                              {
                                attrs: {
                                  primary: "",
                                  "class-names": "closed-search-button",
                                },
                                on: { click: _vm.searchModeOpen },
                              },
                              [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("search"),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chatListToolbarLocked
                      ? _c(
                          "div",
                          {
                            staticClass: "material-icons btnLock",
                            on: { click: _vm.toggleLock },
                          },
                          [_vm._v("lock")]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "material-icons btnLock",
                            on: { click: _vm.toggleLock },
                          },
                          [_vm._v("lock_open")]
                        ),
                  ],
                  1
                ),
              ]),
            ]),
      ]),
      _vm._v(" "),
      _vm.contactListFilterMode === "custom"
        ? _c(
            "ContactListFilterToolBar",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.chatListToolbarLocked,
                  expression: "!chatListToolbarLocked",
                },
              ],
            },
            [
              _c(
                "template",
                { slot: "extra" },
                [
                  _vm.contactListFilterMode === "custom"
                    ? _c("ContactGroupButton")
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "filters-tabs" }, [
        _c(
          "div",
          {
            staticClass: "filter-tab",
            class: {
              active:
                !_vm.filters.showUnread &&
                _vm.contactListFilterMode === "custom",
            },
            on: { click: _vm.showAll },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("chatbotv2.all")) +
                "\n            "
            ),
            _vm.contactListFilterMode === "custom"
              ? _c("span", [_vm._v(_vm._s(_vm.getStatsNormalized().all))])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "filter-tab",
            class: {
              active:
                _vm.filters.showUnread &&
                _vm.contactListFilterMode === "custom",
            },
            on: { click: _vm.showUnread },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("mail.unread")) +
                "\n            "
            ),
            _vm.contactListFilterMode === "custom"
              ? _c("span", [_vm._v(_vm._s(_vm.getStatsNormalized().unread))])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "filter-tab",
            class: { active: _vm.contactListFilterMode === "queue" },
            on: { click: _vm.showQueue },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("chatWindow.waiting")) +
                "\n            "
            ),
            _vm.contactListFilterMode === "queue"
              ? _c("span", [_vm._v(_vm._s(_vm.getStatsNormalized().all))])
              : _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.systemStats.waiting +
                        _vm.systemStats.free +
                        _vm.systemStats.late
                    )
                  ),
                ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "filter-tab",
            class: { active: _vm.contactListFilterMode === "chatbot" },
            on: { click: _vm.showChatbot },
          },
          [
            _vm._v("\n            Chatbot\n            "),
            _vm.contactListFilterMode === "chatbot"
              ? _c("span", [_vm._v(_vm._s(_vm.getStatsNormalized().all))])
              : _c("span", [_vm._v(_vm._s(_vm.systemStats.chatbot))]),
          ]
        ),
      ]),
      _vm._v(" "),
      !_vm.chatListToolbarLocked
        ? _c("div", { staticClass: "colors" }, [
            _c("div", { staticClass: "color" }, [
              _c("div", {
                staticClass: "color-circle",
                staticStyle: { "background-color": "#32cd32" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "color-text" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.you"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color" }, [
              _c("div", {
                staticClass: "color-circle",
                staticStyle: { "background-color": "#ffa500" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "color-text" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.others"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color" }, [
              _c("div", {
                staticClass: "color-circle",
                staticStyle: { "background-color": "#9370db" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "color-text" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.queue"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color" }, [
              _c("div", {
                staticClass: "color-circle",
                staticStyle: { "background-color": "#87ceeb" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "color-text" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.chatbotContact"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "color" }, [
              _c("div", {
                staticClass: "color-circle",
                staticStyle: { "background-color": "#d3d3d3" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "color-text" }, [
                _vm._v(_vm._s(_vm.$t("chatWindow.closedContact"))),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "conversations",
          staticClass: "conversation-lists",
          on: { scroll: _vm.scrollListener },
        },
        [
          _vm.contactListGroupBy === "none"
            ? _c(
                "div",
                { staticClass: "conversation-lists-items" },
                _vm._l(_vm.contactList, function (c, index) {
                  return _c("GridContactListItem", {
                    key: (c && c._id) || index,
                    attrs: { contact: c, activeContact: _vm.contact },
                    on: {
                      joinConversation: function ($event) {
                        return _vm.joinConversation(c)
                      },
                    },
                  })
                }),
                1
              )
            : _c(
                "div",
                { staticClass: "chat-groups" },
                _vm._l(_vm.getGroupContacts(), function (group, index) {
                  return _c("div", { key: index, staticClass: "group" }, [
                    _c("div", { staticClass: "group-toolbar" }, [
                      _c(
                        "div",
                        { staticClass: "group-title" },
                        [
                          group.group.type === "agent"
                            ? _c("AgentAvatar", {
                                attrs: {
                                  userID: group.group.id,
                                  size: 20,
                                  "single-char": "",
                                  "status-background-color": "",
                                },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n                        " +
                              _vm._s(group.group.label) +
                              "\n                    "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "actions" }, [
                        group.group.type === "agent" &&
                        !_vm.isUserInList(group.group.id)
                          ? _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                on: {
                                  click: function ($event) {
                                    return _vm.addUserToList(group.group.id)
                                  },
                                },
                              },
                              [_vm._v("zoom_in")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        group.group.type === "agent" &&
                        _vm.isUserInList(group.group.id)
                          ? _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                class: {
                                  "text-danger": _vm.isUserInList(
                                    group.group.id
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeUserFromList(
                                      group.group.id
                                    )
                                  },
                                },
                              },
                              [_vm._v("zoom_out")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            on: {
                              click: function ($event) {
                                return _vm.switchToMultiViewMode(group.group.id)
                              },
                            },
                          },
                          [_vm._v("visibility")]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "conversation-lists-items" },
                      _vm._l(group.contacts, function (c, index) {
                        return _c("GridContactListItem", {
                          key: group.group.id + index,
                          attrs: { contact: c, activeContact: _vm.contact },
                          on: {
                            joinConversation: function ($event) {
                              return _vm.joinConversation(c)
                            },
                          },
                        })
                      }),
                      1
                    ),
                  ])
                }),
                0
              ),
          _vm._v(" "),
          _vm.contactList.length <= 0
            ? _c("div", { staticClass: "empty-conversations" }, [
                _c(
                  "div",
                  { staticClass: "empty-conversations-content" },
                  [
                    _c("NoConversations"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "empty-conversations-content-title" },
                      [_vm._v(_vm._s(_vm.$t("message.noActiveChat")) + ".")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "empty-conversations-content-description",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.noConversationDesc")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "empty-conversations-content-action" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            attrs: { primary: "" },
                            on: { click: _vm.forwardCustomerUrl },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("message.customerPage")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }